import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppLayout from '@/pages/app/components/AppLayout';

interface FaqItem {
  q: string;
  a: string;
}

interface FaqCategory {
  id: string;
  label: string;
  icon: string;
  items: FaqItem[];
}

const faqData: FaqCategory[] = [
  {
    id: '보험 청구',
    label: '보험 청구',
    icon: 'ri-shield-check-line',
    items: [
      {
        q: '가족이 간병해도 보험금 지급이 가능한가요?',
        a: '가능합니다. 대부분의 간병보험은 가족이 직접 간병해도 조건만 충족하면 보험금 지급이 가능합니다. 보험사별로 필요 서류와 인정 기준이 조금씩 다르니 코리아케어러스에 문의하시면 정확히 안내해 드립니다.',
      },
      {
        q: '간병비 소급 적용이 가능한가요?',
        a: '불가능합니다. 간병인은 등록된 일자부터 자격이 인정되며, 등록 이전의 간병 이력은 보험사에서 인정되지 않아 소급 적용이 불가합니다. 소급적용이 된다고 하는 업체가 있다면 주의하셔야 합니다. 코리아케어러스는 정도영업을 준수합니다.',
      },
      {
        q: '보험 청구는 어떤 절차로 진행되나요?',
        a: '코리아케어러스에 가족간병인으로 등록 → 간병 시작 → 퇴원 후 필요 서류(입퇴원확인서, 간병일지, 간병비 이체 영수증, 간병인 신분증 사본) 카카오톡으로 전송 → 코리아케어러스 서류 검토 후 보험사 제출 → 보험금 수령 순으로 진행됩니다.',
      },
      {
        q: '보험 청구 후 보험금은 얼마나 걸려 지급되나요?',
        a: '보험사마다 다르지만 일반적으로 서류 제출 후 7~14 영업일 이내에 보험금이 지급됩니다. 서류 누락이나 보험사 심사 지연으로 추가 시간이 소요될 수 있으며, 진행 상황은 저희를 통해 확인하실 수 있습니다.',
      },
      {
        q: '여러 보험사에 중복 청구가 가능한가요?',
        a: '네, 가능합니다. 간병보험은 실손보험과 달리 정액 지급 방식으로 여러 보험사에 중복 청구가 가능합니다. 가입하신 보험 내역을 모두 확인하여 빠짐없이 청구하시길 권장합니다.',
      },
    ],
  },
  {
    id: '간병인 등록',
    label: '간병인 등록',
    icon: 'ri-user-heart-line',
    items: [
      {
        q: '간병인 자격증 없이 가족 간병이 가능한가요?',
        a: '물론입니다. 가족간병인은 별도의 국가자격증이나 교육 과정이 필요하지 않습니다. 코리아케어러스에 공식적으로 등록만 해도 보험사에서 인정하는 간병인으로 활동하실 수 있습니다.',
      },
      {
        q: '가족간병인 등록은 어떻게 하나요?',
        a: '앱 내 \'가족간병 신청\' 메뉴에서 간단한 정보를 입력하거나, 전화(1566-8654)로 연락주시면 담당자가 등록 절차를 안내해 드립니다. 등록은 5분 이내로 빠르게 완료됩니다.',
      },
      {
        q: '등록 후 바로 간병을 시작할 수 있나요?',
        a: '네, 등록 완료 즉시 간병을 시작하실 수 있습니다. 단, 등록 이전의 간병 기간은 소급 인정이 되지 않으므로, 입원과 동시에 혹은 간병 시작 전에 반드시 먼저 등록해 주세요.',
      },
      {
        q: '배우자나 직계가족이 아니어도 등록이 가능한가요?',
        a: '가능합니다. 형제자매, 며느리·사위 등 가족 범위 내의 분들도 등록 가능합니다. 단, 보험사별로 인정하는 간병인 범위가 다를 수 있으니 가입 보험 약관을 확인하거나 저희에게 문의해 주세요.',
      },
    ],
  },
  {
    id: '서류 안내',
    label: '서류 안내',
    icon: 'ri-file-list-3-line',
    items: [
      {
        q: '코리아케어러스에 제출해야 할 서류가 뭔가요?',
        a: '퇴원 시 ① 입·퇴원 확인서 ② 간병일지(코리아케어러스 공식 양식) ③ 간병비 이체 영수증(1일 최소 10만원) ④ 간병인 신분증 앞면, 이 4가지를 카카오톡 채팅방으로 보내주시면 됩니다.',
      },
      {
        q: '간병일지는 어디서 받을 수 있나요?',
        a: '코리아케어러스 홈페이지의 \'필요서류 안내\' 페이지에서 JPG 또는 PDF 파일로 다운로드하실 수 있습니다. 프린트하여 매일 작성하신 후 간병인 서명을 받아 보관해 주세요.',
      },
      {
        q: '간병일지는 반드시 매일 작성해야 하나요?',
        a: '네, 필수입니다. 간병일지는 보험사에서 간병 사실을 인정하는 핵심 서류입니다. 간병 기간 동안 매일 작성하고, 간병인 서명을 받아야 보험금 청구 시 인정받을 수 있습니다.',
      },
      {
        q: '간병비는 어떻게 이체해야 하나요?',
        a: '간병비는 간병인과 환자가 직접 협의하여 이체합니다. 보험 청구를 위해서는 보험 청구자 본인 명의 계좌에서 간병인 본인 명의 계좌로 이체한 내역(거래 영수증)이 필요합니다. 현금 지급이나 제3자 명의 이체는 보험사에서 인정받지 못할 수 있습니다.',
      },
    ],
  },
  {
    id: '비용 안내',
    label: '비용 안내',
    icon: 'ri-coin-line',
    items: [
      {
        q: '코리아케어러스 서비스 이용 비용이 있나요?',
        a: '코리아케어러스는 간병인과 환자를 연결하는 플랫폼으로, 가족간병 수수료를 받습니다. 가족간병 수수료는 일 4,000원을 기준으로 하되 최소 10,000원, 최대 100,000원으로 책정됩니다. 예를 들어 1~2일은 10,000원, 3일은 12,000원이며, 기간에 상관없이 최대 100,000원입니다. 또한 기본 간병인 1명을 기준으로, 간병인이 추가되면 추가 인원 1명당 10,000원이 부과됩니다. 숨겨진 추가 비용은 없으며, 자세한 내용은 전화(1566-8654) 또는 홈페이지를 통해 문의해 주시면 상세히 안내해 드립니다.',
      },
      {
        q: '간병비는 하루에 얼마나 이체해야 하나요?',
        a: '보험사에서 정상 간병으로 인정받기 위해서는 1일 최소 10만원 이상 이체해야 합니다. 이체 금액이 이보다 적을 경우 보험금 청구가 거절되거나 감액될 수 있습니다.',
      },
      {
        q: '보험금 수령 금액은 어떻게 결정되나요?',
        a: '보험금은 가입하신 보험 약관에 따라 결정됩니다. 일반적으로 간병 일수 × 일당 보험금으로 계산되며, 보험사 및 가입 플랜에 따라 금액이 다릅니다. 가입 내역을 확인하시거나 저희에게 문의해 주시면 예상 보험금을 안내해 드립니다.',
      },
    ],
  },
  {
    id: '간병인 매칭',
    label: '간병인 매칭',
    icon: 'ri-user-search-line',
    items: [
      {
        q: 'AI 추천 간병인은 무엇인가요?',
        a: 'AI 추천은 환자/보호자의 지역과 간병인의 거리, 평점, 경력, 보유 자격증 수, 매칭 신뢰도 등 6가지 요소를 종합적으로 분석해 점수로 환산한 뒤, 현재 검색 조건 내에서 가장 적합한 1명을 자동으로 선정해 주는 기능입니다. 카드 왼쪽 상단에 반짝이 아이콘과 함께 "AI 추천" 배지가 표시되며, 내 지역과 가깝고 평점이 높은 간병인일수록 추천될 확률이 높아집니다. 단, 추천 점수가 일정 기준(60점) 미만이면 무리하게 추천 배지를 띄우지 않아 신뢰도를 유지합니다.',
      },
      {
        q: '우수간병인 배지는 어떤 기준으로 부여되나요?',
        a: '우수간병인은 간병 완료 10회 이상 & 평균 평점 4.8점 이상이라는 두 가지 객관적 기준을 모두 충족한 간병인에게 부여되는 공식 인증 배지입니다. 카드 오른쪽 상단에 인증 뱃지 아이콘과 함께 "우수간병인"으로 표시되며, 이는 AI 추천(개인 맞춤형)과 달리 플랫폼 내에서 실적으로 검증된 간병인임을 의미합니다. 두 배지는 서로 다른 기준이므로 한 간병인에게 동시에 표시될 수도 있습니다.',
      },
      {
        q: 'AI 추천과 우수간병인 배지가 모두 붙은 간병인이 가장 좋은 건가요?',
        a: '일반적으로 그렇습니다. AI 추천은 "현재 검색 조건에서 나에게 가장 적합한 간병인"을 의미하고, 우수간병인은 "플랫폼 전체에서 실적과 평점이 입증된 간병인"을 의미합니다. 두 배지를 모두 가진 간병인은 객관적 실적도 뛰어나면서 동시에 내 조건과도 잘 맞는 분이므로 우선적으로 고려하시길 권장합니다. 다만 간병 스타일, 대화 호흡 등은 실제 대화를 통해 확인하시는 것이 가장 중요합니다.',
      },
    ],
  },
  {
    id: '기타 문의',
    label: '기타 문의',
    icon: 'ri-chat-smile-3-line',
    items: [
      {
        q: '가족간병은 전국 어디서든 이용할 수 있나요?',
        a: '네, 코리아케어러스는 전국을 대상으로 가족간병 등록과 간병보험 청구 서류 발급을 지원합니다. 본사는 전주에 있지만 거주 지역과 상관없이 전화·온라인으로 등록과 상담이 가능하며, 필요 서류도 발급 후 받아보실 수 있습니다.',
      },
      {
        q: '입원 기간 중 간병인이 교대해도 되나요?',
        a: '네, 가능합니다. 다만 교대하는 간병인도 모두 코리아케어러스에 등록되어 있어야 하며, 각 간병인별로 간병일지를 정확히 작성하고 이체 내역을 유지해야 합니다.',
      },
      {
        q: '이미 퇴원했는데 청구가 가능한가요?',
        a: '등록 이전 기간의 소급 적용은 불가하지만, 등록 기간 내 간병에 대해서는 퇴원 후에도 청구가 가능합니다. 단, 필요 서류(간병일지, 이체 내역 등)가 갖춰져 있어야 합니다. 자세한 사항은 상담을 통해 확인해 드립니다.',
      },
      {
        q: '카카오톡으로도 상담이 가능한가요?',
        a: '네, 가능합니다. 서류 제출도 카카오톡 채팅방을 통해 진행하시면 됩니다. 전화(1566-8654) 또는 채팅 상담 모두 평일 오전 9시 ~ 오후 6시에 이용하실 수 있습니다.',
      },
      {
        q: '간병인도 소득신고를 해야 하나요?',
        a: '네, 간병인은 간병으로 발생한 수익에 대한 소득세 및 세무 신고 의무가 있습니다. 소득신고는 간병인 본인이 직접 하셔야 하며, 코리아케어러스는 중개 플랫폼으로서 간병인의 소득신고를 대행하지 않습니다.',
      },
    ],
  },
];

export default function AppFaqPage() {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState('보험 청구');
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  const currentCategory = faqData.find((c) => c.id === activeCategory)!;

  return (
    <AppLayout>
      <div className="min-h-screen pb-24 bg-[#F8F9FA]">
        {/* 헤더 */}
        <div className="px-5 pt-6 pb-4 flex items-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="w-9 h-9 rounded-xl border border-gray-200 bg-white flex items-center justify-center cursor-pointer hover:bg-gray-50 transition-colors"
          >
            <i className="ri-arrow-left-line text-gray-600" />
          </button>
          <h1 className="text-lg font-extrabold text-gray-900">자주 묻는 질문</h1>
        </div>

        {/* 카테고리 탭 */}
        <div className="px-5 mb-5">
          <div className="flex overflow-x-auto gap-2 pb-1 no-scrollbar">
            {faqData.map((cat) => (
              <button
                key={cat.id}
                onClick={() => { setActiveCategory(cat.id); setOpenIdx(0); }}
                className="flex items-center gap-1.5 px-3.5 py-2 rounded-full text-xs font-bold whitespace-nowrap cursor-pointer transition-all flex-shrink-0"
                style={{
                  backgroundColor: activeCategory === cat.id ? '#2E7D6B' : '#fff',
                  color: activeCategory === cat.id ? '#fff' : '#6b7280',
                  border: activeCategory === cat.id ? '1.5px solid #2E7D6B' : '1.5px solid #e5e7eb',
                }}
              >
                <i className={`${cat.icon} text-xs`} />
                {cat.label}
                <span className="text-[10px] opacity-70">({cat.items.length})</span>
              </button>
            ))}
          </div>
        </div>

        {/* 아코디언 */}
        <div className="px-5">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-7 h-7 rounded-lg bg-[#E8F5E9] flex items-center justify-center">
              <i className={`${currentCategory.icon} text-sm text-[#2E7D6B]`} />
            </div>
            <span className="text-sm font-bold text-gray-900">{currentCategory.label}</span>
            <span className="text-xs text-gray-400">· {currentCategory.items.length}개의 질문</span>
          </div>

          <div className="space-y-2.5">
            {currentCategory.items.map((item, i) => (
              <div
                key={`${activeCategory}-${i}`}
                className="rounded-xl overflow-hidden bg-white border transition-all"
                style={{ borderColor: openIdx === i ? '#2E7D6B' : '#f0f0f0' }}
              >
                <button
                  onClick={() => setOpenIdx(openIdx === i ? null : i)}
                  className="w-full flex items-center justify-between px-4 py-3.5 text-left cursor-pointer"
                >
                  <span className="text-sm font-semibold text-gray-900 flex items-center gap-2.5 pr-2">
                    <span
                      className="w-6 h-6 flex items-center justify-center rounded-md text-[11px] font-bold flex-shrink-0 transition-colors"
                      style={{
                        backgroundColor: openIdx === i ? '#2E7D6B' : '#E8F5E9',
                        color: openIdx === i ? '#fff' : '#2E7D6B',
                      }}
                    >
                      Q
                    </span>
                    <span className="line-clamp-2">{item.q}</span>
                  </span>
                  <i
                    className={`flex-shrink-0 text-base transition-colors ${openIdx === i ? 'ri-subtract-line text-[#2E7D6B]' : 'ri-add-line text-gray-400'}`}
                  />
                </button>
                {openIdx === i && (
                  <div className="px-4 pb-4 flex gap-2.5">
                    <span
                      className="w-6 h-6 flex items-center justify-center rounded-md text-[11px] font-bold flex-shrink-0 mt-0.5"
                      style={{ backgroundColor: '#E8F5E9', color: '#2E7D6B' }}
                    >
                      A
                    </span>
                    <p className="text-sm text-gray-600 leading-relaxed">{item.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* 하단 문의 */}
        <div className="px-5 mt-8">
          <div className="bg-white rounded-2xl p-5 border border-gray-100">
            <p className="text-sm font-bold text-gray-900 mb-1">원하는 답변을 찾지 못하셨나요?</p>
            <p className="text-xs text-gray-400 mb-4">아래 방법으로 직접 문의해 주세요.</p>
            <div className="space-y-2.5">
              <a
                href="tel:1566-8654"
                className="flex items-center gap-3 p-3 rounded-xl bg-[#f0f9f6] cursor-pointer hover:opacity-90 transition-opacity"
              >
                <div className="w-9 h-9 rounded-lg bg-[#E8F5E9] flex items-center justify-center">
                  <i className="ri-phone-line text-[#2E7D6B]" />
                </div>
                <div className="flex-1">
                  <p className="text-sm font-bold text-gray-900">전화 상담</p>
                  <p className="text-xs text-gray-400">1566-8654</p>
                </div>
                <i className="ri-arrow-right-s-line text-gray-300" />
              </a>
              <a
                href="https://pf.kakao.com/_SNpdX/chat"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 p-3 rounded-xl bg-[#FEE500] cursor-pointer hover:opacity-90 transition-opacity"
              >
                <div className="w-9 h-9 rounded-lg bg-black/10 flex items-center justify-center">
                  <i className="ri-chat-3-line text-black/70" />
                </div>
                <div className="flex-1">
                  <p className="text-sm font-bold text-black/80">카카오톡 상담</p>
                  <p className="text-xs text-black/50">채팅으로 편리하게 문의</p>
                </div>
                <i className="ri-arrow-right-s-line text-black/40" />
              </a>
            </div>
            <p className="text-[10px] text-gray-400 text-center mt-4">
              운영시간: 평일 09:00 ~ 18:00 (주말/공휴일 제외)
            </p>
          </div>
        </div>
      </div>
    </AppLayout>
  );
}